import { Footer } from '@global-dax-ad-platform/dax-components';
import {
  ApplicationLayout,
  Navigation,
  NavigationLayout,
  useNavigation,
} from '@global-engineering-shared/gweb-material-lab';
import { useEffect } from 'react';

import LoadableComponent from 'components/LoadableComponent';
import { useAuth } from 'context/AuthProvider/AuthProvider';
import useDraftsCount from 'hooks/useDraftsCount';
import AppRoutes from 'routes/Routes';
import { FOOTER_LINKS } from 'utils/defaults';
import { getDefaultNavigationItems } from 'utils/sideNavBar';

const AppLayout = () => {
  const { isSignedIn } = useAuth();
  const { setNavigationItems } = useNavigation();
  const draftsCount = useDraftsCount(isSignedIn);

  useEffect(() => {
    setNavigationItems(getDefaultNavigationItems(draftsCount));
  }, [draftsCount, setNavigationItems]);

  return (
    <NavigationLayout>
      {isSignedIn ? (
        <>
          <Navigation />
          <ApplicationLayout>
            <AppRoutes />
            <Footer footerLinks={FOOTER_LINKS} />
          </ApplicationLayout>
        </>
      ) : (
        <LoadableComponent loading={true} />
      )}
    </NavigationLayout>
  );
};

export default AppLayout;
